
// Change text captialize format
// ex: 'iron, man' -'Iron, Man'  &  'iron,man' -'Iron Man'
export const TitleCase = (str) => {
    if (str) {
        return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
    }
    return str;

};



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/utils/caseFormat.ts